import type { ComponentPropsWithoutRef } from 'react'
import { Switch as SwitchPrimitive } from 'radix-ui'
import { cn } from '@/shared/lib/cn'
import s from './Switch.module.css'

/**
 * Управляемый всегда: `checked` и `onCheckedChange` обязательны, `defaultChecked` закрыт.
 *
 * Тип Radix целиком делает их необязательными — тогда `<Switch />` без обработчика
 * визуально переключается и молча ничего не сохраняет. В Студии тумблеров десятки,
 * и такой баг доехал бы до прода незамеченным. Остальные пропсы Radix (`id`, `aria-label`,
 * `aria-labelledby`, `disabled`) пробрасываются — без них переключатель безымянный.
 */
type SwitchProps = Omit<
  ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>,
  'checked' | 'onCheckedChange' | 'defaultChecked'
> & {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

export function Switch({ className, ...rest }: SwitchProps) {
  return (
    <SwitchPrimitive.Root className={cn(s.root, className)} {...rest}>
      <SwitchPrimitive.Thumb className={s.thumb} />
    </SwitchPrimitive.Root>
  )
}
